export enum AlertType {
  AmberAlert = 'amber',
  RedAlert = 'red',
}

export enum TriggerType {
  Button = 'button',
  ExpiredTimer = 'expired_timer',
}

export enum TriggerSource {
  Button = 'button',
  FallDetection = 'fall_detection',
  Discreet = 'discreet',
  AmberExpired = 'amber_expired',
}

export enum EscalationActionType {
  CALL = 'call',
  EMAIL = 'email',
  PUSH_NOTIFICATION = 'push_notification',
}
export enum ActionFlow {
  SEQUENTIAL = 'sequential',
  SIMULTANEOUS = 'simultaneous',
}
